module.exports = __webpack_public_path__ + "img/logo__irwin_homes--light.9a5a3317.png";